import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const ALLOWED_TYPES = ['category', 'color', 'material', 'occasion', 'tag'] as const;

/**
 * Redirects /products/group/:type/:value to /products?type=value
 * e.g. /products/group/color/Red → /products?color=Red
 * Used for SEO-friendly and shareable grouping URLs.
 * Declarative <Navigate /> avoids timing issues with lazy-loaded chunks + useEffect.
 */
const ProductGroup: React.FC = () => {
  const { type, value } = useParams<{ type: string; value: string }>();

  if (!type || !value) {
    return <Navigate to="/products" replace />;
  }
  const paramType = type.toLowerCase();
  if (!ALLOWED_TYPES.includes(paramType as (typeof ALLOWED_TYPES)[number])) {
    return <Navigate to="/products" replace />;
  }
  const search = new URLSearchParams();
  try {
    search.set(paramType, decodeURIComponent(value));
  } catch {
    search.set(paramType, value);
  }
  return <Navigate to={`/products?${search.toString()}`} replace />;
};

export default ProductGroup;
